import {
	createHook,
	type Action,
	type BoundActions,
	type GetState,
	type HookFunction,
	type SetState,
} from 'react-sweet-state';

import { Store } from '../../main';

export const useOrg: HookFunction<
	{
		orgId?: string;
	},
	BoundActions<
		{
			orgId?: string;
		},
		{
			setOrgId: (orgId?: string) => ({
				setState,
			}: {
				setState: SetState<{
					orgId?: string;
				}>;
				getState: GetState<{
					orgId?: string;
				}>;
				dispatch: <
					T extends Action<
						{
							orgId?: string;
						},
						any,
						any
					>,
				>(
					actionThunk: T,
				) => ReturnType<T>;
			}) => void;
		}
	>,
	void
> = createHook(Store);
